var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"color":"primary","loading":_vm.loading,"disabled":_vm.cerrada},on:{"click":_vm.onSubmit}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-printer")]),_vm._v("\n    Imprimir\n  ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }